import * as z from "zod/mini";

/**
 * @description
 * isFeatureEnabled の引数を以下の理由により up cast するためのスキーマ
 * - 型定義上、引数は discriminated union にしておきたい
 *   - featureName を軸に必須プロパティを可変させるため
 *   - feature flag の除却時に discriminated union による型エラーで除却箇所を特定するため
 * - 処理としては全てのオプションを網羅しておきたい
 *   - その時々で使われてるプロパティが異なるため
 *
 * 以上によりこちらのスキーマが isFeatureEnabled で扱われる option の全量となる
 */
export const OptionSchema = z.object({
  email: z.optional(z.string()),
  eventId: z.optional(z.string()),
  featureName: z.string(),
  isEnabledAtDevelopment: z.optional(z.boolean()),
});
